<template>
  <EXTooltip
    class="checkpoint-operations-lock-icon"
    placement="top"
    :title="LOCK_TOOLTIP"
    :delay="200"
    data-testid="checkpoint-operations-lock-icon"
  >
    <span class="checkpoint-operations-lock-icon__hit" role="img" :aria-label="LOCK_TOOLTIP">
      <Icon name="lock_icon" />
    </span>
  </EXTooltip>
</template>

<script>
export default {
  name: "CheckpointOperationsLockIcon",
};
</script>

<script setup>
import Icon from "@components/icons/Icon.vue";
import EXTooltip from "@components/tooltip/EXTooltip.vue";

/** Exact copy from Rule 5 — do not paraphrase. */
const LOCK_TOOLTIP = "No Checkpoint operations are allowed while the checkpoint is locked.";
</script>

<style scoped>
.checkpoint-operations-lock-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.checkpoint-operations-lock-icon__hit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  cursor: default;
  user-select: none;
}

.checkpoint-operations-lock-icon :deep(svg path) {
  stroke: #344054;
}
</style>
